export default __webpack_public_path__ + "img/Poppins-Black_d84bd93.woff";